import { Component, Prop } from 'vue-property-decorator';
import { getPhoneNumberCountriesBySu } from '@/config/app.config';
import Vue from 'vue';
import ApiService from '@/services/api.service';

@Component
export default class InputTel extends Vue {
  @Prop({ required: true }) public name?: string;
  @Prop() public label?: string;
  @Prop({ default: false }) public required?: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ default: false }) public readonly?: boolean;
  @Prop() public placeholder?: string;
  @Prop() public value?: string;
  @Prop({default: 'CH'}) public defaultCountry?: string;
  @Prop({default: true}) public dynamicPlaceholder?: boolean;
  @Prop({default: 'national'}) public mode?: string;
  @Prop({default: false}) public validateMobile?: boolean;
  public onlyCountries: string[] = [];
  public mobileWarning = false;
  protected randomId: string = Math.floor(Math.random() * Math.floor(100000000)).toString();

  public async onBlur(): Promise<void> {
    if (!this.validateMobile) {
      return;
    }
    await this.checkMobile(this.value);
  }

  protected mounted() {
    this.onlyCountries = getPhoneNumberCountriesBySu(this.$route.params.screening);
  }

  private async checkMobile(phoneNumber: string | null | undefined): Promise<void> {
    if (!phoneNumber || !phoneNumber.trim()) {
      this.mobileWarning = false;
      return;
    }
    const validationUrl = `${process.env.VUE_APP_PUBLIC_ROOT_API}/PhoneNumbers/mobile-validation`;
    const response = await ApiService.post(validationUrl, { phoneNumber });
    this.mobileWarning = !response.data.isMobile;
  }
}
